import Logo from 'assets/img/cognito-header.png';
import favicon from 'assets/img/favicon.svg';

export const favLogo = favicon;
export const logo = Logo;
